import {RunStates} from './runStates'
import defaultSettings from './defaultSettings'

export function resetAfterFeatureChanges (state) {
  state.cvState = RunStates.NOT_RUN
  state.classifyState = RunStates.NOT_RUN
  state.crossValidationResults = {}
  state.testTextResults = []
  state.experimentSaved = false
}

export function resetResultsAndMarkUnsaved (state) {
  state.featuresState = RunStates.NOT_RUN
  state.features = {}
  state.removedFeatures = defaultSettings.getDefaultRemovedFeatures()
  resetAfterFeatureChanges(state)
}

export function resetTestResultsAndMarkUnsaved (state) {
  state.classifyState = RunStates.NOT_RUN
  state.testTextResults = []
  state.experimentSaved = false
}



// WEBPACK FOOTER //
// ./src/store/resetState.js